module.exports = __webpack_public_path__ + "static/img/logo1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo1.png
// module id = TrFT
// module chunks = 0